import React from 'react';
import { PreviewConfig } from '~/components/preview/config';
import { FacebookSpinner } from './facebook-spinner';
import PreviewPanel from './preview-panel';

type Props = {
    config: PreviewConfig;
    active?: boolean;
};

function PreviewFacebook(props: Props) {
    const { config, active } = props;
    const facebook = config.facebook;
    if (active && facebook) {
        const height = 687;
        const width = 502;
        const top = 72;
        const left = 313;
        const phoneHeight = 530;
        const phoneWidth = 320;
        const phoneTop = 95;
        const phoneLeft = -1;

        return (
            <div className="preview-panels">
                <section className="desktop">
                    <h4 className="u-screen-reader-only">Forhåndsvisning desktop</h4>
                    <PreviewPanel
                        height={height}
                        width={width}
                        backgroundImageUrl={`https://static.finncdn.no/_c/distribution-studio/facebook/desktop.png`}
                        backgroundHeight={761}
                        backgroundWidth={1128}
                        url={facebook.desktop?.src || ''}
                        title="Forhåndsvisning desktop"
                        top={top}
                        left={left}
                        ratio="67%"
                        spinner={FacebookSpinner}
                    />
                </section>

                <section className="phone">
                    <h4 className="u-screen-reader-only">Forhåndsvisning mobil</h4>
                    <PreviewPanel
                        height={phoneHeight}
                        width={phoneWidth}
                        backgroundImageUrl={`https://static.finncdn.no/_c/distribution-studio/facebook/phone.png`}
                        loadingBackgroundImageUrl={`https://static.finncdn.no/_c/distribution-studio/facebook/phone-loading.png`}
                        backgroundHeight={693}
                        backgroundWidth={320}
                        url={facebook.mobile?.src || ''}
                        title="Forhåndsvisning mobil"
                        top={phoneTop}
                        left={phoneLeft}
                        ratio="216%"
                    />
                </section>
            </div>
        );
    }
    return null;
}

export default PreviewFacebook;
